import { render, staticRenderFns } from "./AsideBar.vue?vue&type=template&id=9b5d2a4a&scoped=true"
import script from "./AsideBar.vue?vue&type=script&lang=js"
export * from "./AsideBar.vue?vue&type=script&lang=js"
import style0 from "./AsideBar.vue?vue&type=style&index=0&id=9b5d2a4a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5d2a4a",
  null
  
)

export default component.exports